import { apiGenerator } from "../generic/all.api";
import CONFIG from "./employeeAccount.config";
export var getPaged = apiGenerator({
    resource: CONFIG.RESOURCE,
}).getPaged;
